const init = {
    loading: false,
    audioRequest: null,
    audioResponse: undefined,
    isSaved: false
  };
  
  export const announcementAudio = (state = init, action) => {
    switch (action.type) {
      
      case "FETCH_ANNOUNCEMENT_AUDIO_SUCCESS":
        return { ...state, loading: false, audioResponse: action.payload };
      case "FETCH_ANNOUNCEMENT_AUDIO_FAILURE":
        return { ...state, loading: false, error: action.payload };
      case "FETCH_ANNOUNCEMENT_AUDIO_START":
        return { ...state, loading: true };
      default:
        return state;
    }
  };
  